import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSales = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55 49" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#979797">
      <path d="M.5.5v29h54V.5H.5zM9 29V1m36 28V1" />
      <g transform="translate(19 6)">
        <ellipse cx={8.5} cy={9.429} rx={8.5} ry={8.571} />
        <ellipse cx={8.5} cy={9.429} rx={4.25} ry={8.571} />
        <path d="M.24 9.19h16.653M8.73.742v17.224" />
      </g>
      <path d="M0 32.044C22.039 31.618 38.705 34.27 50 40c-.038-2.58-.038-5.232 0-7.956M43 31v5" />
      <path d="M0 34.059C19.9 33.415 35.566 38.062 47 48v-8.092M41 39v5" />
    </g>
  </svg>
);
const Memo = memo(SvgSales);
export default Memo;
